import { Dayjs } from 'dayjs';

import {
  MultiraceProgram,
  MultiraceReleaseStatus,
  MultiraceType,
} from '@/lib/apollo/types/gen/graphql';
import { dayjst } from '@/lib/dayjst';

import { raceSelector } from '../race';

class MultiraceProgramSelector {
  private mp: MultiraceProgram;

  constructor(initialState: MultiraceProgram) {
    this.mp = initialState;
  }

  get marginedSalesDeadline(): Dayjs {
    return this.mp.salesDeadline.subtract(10, 's');
  }

  get isReleased(): boolean {
    return MultiraceReleaseStatus.OnSale === this.mp.releaseStatus;
  }

  get isBettable(): boolean {
    if (this.mp.raceProgram.isSalesSuspended) {
      return false;
    }
    return this.isReleased && dayjst().isBefore(this.marginedSalesDeadline);
  }

  get isCanceled(): boolean {
    return (
      this.mp.isCanceled ||
      this.mp.raceProgram.isCanceled ||
      this.mp.targetRaceNumbers.some(num => {
        const targetRace = this.mp.raceProgram.races[num - 1];
        return targetRace ? raceSelector(targetRace).isCanceled : true;
      })
    );
  }

  get isSelect(): boolean {
    return [
      MultiraceType.CharilotoSelect,
      MultiraceType.Chariloto3,
      MultiraceType.Chariloto5,
    ].includes(this.mp.multiraceType);
  }

  get isRandom(): boolean {
    return !this.isSelect;
  }
}

export const multiraceProgramSelector = (
  multiraceProgram: MultiraceProgram,
) => {
  return new MultiraceProgramSelector(multiraceProgram);
};
